import { render, staticRenderFns } from "./pending-tab.vue?vue&type=template&id=5d71fa2a&"
import script from "./pending-tab.vue?vue&type=script&lang=js&"
export * from "./pending-tab.vue?vue&type=script&lang=js&"
import style0 from "./pending-tab.vue?vue&type=style&index=0&id=5d71fa2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports